import React, { useState, useRef } from 'react';
import { Gift } from 'lucide-react';
import { motion } from 'framer-motion';
const bonos = [{
  id: 1,
  title: 'Tomo Especial de Fichas: Las Materias Más Difíciles Resueltas',
  value: '$12.000'
}, {
  id: 2,
  title: 'Banco de Juegos y Actividades: +100 Recursos Listos para Tus Clases',
  value: '$10.000'
}, {
  id: 3,
  title: 'Calendario del Estudiante: Tu Cuatrimestre Organizado desde el Día Uno',
  value: '$9.000'
}, {
  id: 4,
  title: 'Primeros Auxilios en EF: Protocolo Completo para el Docente',
  value: '$10.000'
}, {
  id: 5,
  title: 'Oratoria y Comunicación Docente: Hablá Frente al Grupo con Confianza',
  value: '$9.000'
}, {
  id: 6,
  title: 'Simulacro de Parcial Completo: 8 Simulacros con Respuestas Modelo',
  value: '$8.000'
}];
export function BonosSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const {
      scrollLeft,
      scrollWidth
    } = scrollRef.current;
    const itemWidth = scrollWidth / bonos.length;
    setActiveIndex(Math.round(scrollLeft / itemWidth));
  };
  return <section className="py-10 md:py-16 bg-brand-50 border-y border-brand-100 overflow-hidden" data-id="element-27">
      <div className="max-w-5xl mx-auto px-4" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-10" data-id="element-29">
          <p className="text-brand-600 font-bold uppercase tracking-wider mb-1 md:mb-2 text-xs md:text-sm" data-id="element-30">
            Incluidos en todas las ofertas — sin costo extra
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-brand-950 flex items-center justify-center gap-2 md:gap-4 flex-wrap" data-id="element-31">
            Más los 6 Bonos Estratégicos
          </h2>
        </motion.div>

        {/* Mobile Carousel */}
        <div className="md:hidden mb-8" data-id="element-32">
          <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar gap-3 pb-4 -mx-4 px-4" data-id="element-33">
            {bonos.map(bono => <motion.div key={bono.id} whileTap={{
            scale: 0.98
          }} className="min-w-[80%] snap-center bg-white rounded-2xl p-4 shadow-sm border border-brand-100 relative overflow-hidden flex flex-col" data-id="element-34">
                <div className="absolute -right-4 -top-4 w-16 h-16 bg-accent-50 rounded-full flex items-center justify-center" data-id="element-35">
                  <Gift className="w-6 h-6 text-accent-500 ml-2 mt-2" data-id="element-36" />
                </div>
                <div className="inline-block bg-accent-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full mb-3 self-start" data-id="element-37">
                  GRATIS
                </div>
                <p className="text-xs font-bold text-brand-400 mb-1" data-id="element-38">
                  BONO {bono.id}
                </p>
                <h3 className="text-sm font-bold text-brand-900 mb-4 pr-6 leading-snug flex-grow" data-id="element-39">
                  {bono.title}
                </h3>
                <div className="pt-3 border-t border-gray-100 flex items-center justify-between mt-auto" data-id="element-40">
                  <span className="text-xs text-gray-500 font-medium" data-id="element-41">
                    Valor: <span className="line-through" data-id="element-42">{bono.value}</span>
                  </span>
                  <span className="text-accent-600 font-black text-xs" data-id="element-43">
                    → GRATIS
                  </span>
                </div>
              </motion.div>)}
          </div>
          <div className="flex justify-center gap-1.5 mt-1" data-id="element-44">
            {bonos.map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all duration-300 ${i === activeIndex ? 'w-4 bg-brand-600' : 'w-1.5 bg-gray-300'}`} data-id="element-45" />)}
          </div>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-12" data-id="element-46">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} whileHover={{
          y: -4,
          scale: 1.02
        }} className="bg-white rounded-2xl p-5 shadow-sm border border-brand-100 relative overflow-hidden group flex flex-col" data-id="element-47">
              <div className="absolute -right-6 -top-6 w-20 h-20 bg-accent-50 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-48">
                <Gift className="w-7 h-7 text-accent-500 ml-3 mt-3" data-id="element-49" />
              </div>
              <div className="inline-block bg-accent-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-4 self-start" data-id="element-50">
                GRATIS
              </div>
              <p className="text-xs font-bold text-brand-400 mb-1" data-id="element-51">
                BONO {bono.id}
              </p>
              <h3 className="text-base font-bold text-brand-900 mb-6 pr-8 leading-snug flex-grow" data-id="element-52">
                {bono.title}
              </h3>
              <div className="pt-4 border-t border-gray-100 flex items-center justify-between mt-auto" data-id="element-53">
                <span className="text-sm text-gray-500 font-medium" data-id="element-54">
                  Valor: <span className="line-through" data-id="element-55">{bono.value}</span>
                </span>
                <span className="text-accent-600 font-black text-sm" data-id="element-56">
                  → GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-900 rounded-2xl p-4 md:p-8 text-center shadow-xl max-w-3xl mx-auto transform -rotate-1 hover:rotate-0 transition-transform" data-id="element-57">
          <p className="text-sm md:text-xl font-medium text-brand-200 mb-1 md:mb-2" data-id="element-58">
            Valor total de los 6 bonos:{' '}
            <span className="line-through opacity-70" data-id="element-59">$58.000</span>
          </p>
          <h3 className="text-xl md:text-3xl font-black text-white flex items-center justify-center gap-2 md:gap-3" data-id="element-60">
            <Gift className="w-5 h-5 md:w-8 md:h-8 text-accent-400" data-id="element-61" />
            GRATIS{' '}
            <span className="text-sm md:text-xl font-medium text-brand-300" data-id="element-62">
              — Incluidos siempre —
            </span>
          </h3>
        </motion.div>
      </div>
    </section>;
}